import { UIElementProps } from 'types/prop-types';

export function AppContainer({ children }: UIElementProps) {
  return (
    <div className="w-full flex flex-col" style={{ minHeight: '100vh', height: 'auto' }}>
      <>{children}</>
    </div>
  );
}
